export default function Why() {
  const reasons = [
    {
      title: "Expertise & Credentials",
      description:
        "Proven expertise backed by certifications and advanced education.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image16-5342d86d-c298-46a8-875d-225827d89401.svg",
    },
    {
      title: "Real-World Experience",
      description:
        "Hands-on results across cosmetics, ammunition, and industrial refrigeration operations.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image21-93765888-1ddb-41aa-b34e-6954c62c39e2.svg",
    },
    {
      title: "Customized Solutions",
      description:
        "Strategies specifically tailored to your operational needs.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image20-d044d558-18e5-494b-a9f7-9b9735ddfe0a.svg",
    },
    {
      title: "Measurable Results",
      description: "Clear, data-driven improvements and cost reductions.",
      image:
        "https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image19-03fa45f6-33ea-4418-9cb6-1068f40a260b.svg",
    },
  ];

  return (
    <div className="container relative py-16 md:py-36 flex lg:flex-row flex-col">
      <div className="flex-col justify-start items-start flex w-full">
        <div className="mb-12 flex-col justify-center text-center items-center gap-2 inline-flex w-full">
          <div className="p-2 bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
            <div className="text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
              WHY CHOOSE CHARLES BELL
            </div>
          </div>
          <div className="text-center text-[#0e0e0e] text-2xl md:text-[32px] font-semibold font-primary leading-[41.60px]">
            Why Partner with Charismatic Consulting?
          </div>
        </div>

        <div className="gap-[56px] items-start justify-center flex flex-wrap flex-col md:flex-row w-full mb-10 md:mb-20">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="p-3 flex-col justify-center items-center md:max-w-[252px] gap-5 inline-flex
              border border-[transparent] hover:border-[#00479C] transition-all duration-500 rounded-md"
            >
              <div className="flex-col justify-start items-center gap-6 flex">
                <img src={reason.image} alt={reason.title} />
                <div className="text-center text-[#0e0e0e] text-xl font-normal font-primary leading-7 px-[20px]">
                  {reason.title}
                </div>
              </div>
              <div className="text-center text-[#373737] text-base font-light font-primary leading-[22.40px] tracking-[0.01em]">
                {reason.description}
              </div>
            </div>
          ))}
        </div>
        <button
          onClick={() =>
            window.open(
              "https://calendly.com/charismaticconsultingar/",
              "_blank"
            )
          }
          className="p-3 justify-center items-center gap-1.5 flex bg-[#0075ff] hover:bg-[#0E0E0E] transition-all duration-300 rounded mx-auto"
        >
          <div className="text-white text-base font-semibold font-primary leading-5">
            Schedule Your Free Consultation
          </div>
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-e3d7af35-d90e-4bcb-89fd-9563341bc0a1.svg"
            alt="Frame"
          />
        </button>
        <img
          src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Rectangle2-cd111b85-d21e-4815-a11e-997879004c0f.svg"
          alt="Rectangle 2"
          className="absolute right-[22px] top-0 opacity-90 w-10 md:w-auto"
        />
      </div>
    </div>
  );
}
